import { defineStore } from "pinia";
import type { Category } from "@/types";
import {i18n} from "@/i18n";
import getCategories from "@/auth/getCategories";

type StateShape = {
	categories: Record<string, Category>,
};

export const useCategoriesStore = defineStore({
	id: "category",
	state: (): StateShape => ({
		categories: {}
	}),

	getters: {
		getCategories(): Record<string, Category> {
			return this.categories;
		},
		getCategoriesAsArray(): Array<Record<string, string>> {
			if (Object.keys(this.categories).length === 0) return [];
			return Object.keys(this.categories).map(key => ({ id: key, value: this.categories[key].value, color: this.categories[key].color }));
		},
		hasBeenFetched() {
			for(const key in this.categories) {
				if (this.categories.hasOwnProperty(key)) return true	
			}
			return false;
		}
	},

	actions: {
		async init() {
		 if (this.hasBeenFetched) return;

		 const results = await getCategories();

		 if (!results) return;
		 if (results.code) {
			 this.categories = results.response.documents.reduce(
				(prev: Record<string, string>, next: {$id: string, i18n_key: string, color: string}) => ({ ...prev, [next.$id]: { value: i18n.t(`categoriesList.${next.i18n_key}`), color: next.color } }),
				{}
			 )
		 }
		}
	}
})
